module.exports = __webpack_public_path__ + "static/img/logo3.c57f9a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo3.png
// module id = 6q7S
// module chunks = 0